module.exports = __webpack_public_path__ + "static/img/logo_black.ddf5aee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black.jpeg
// module id = 1raj
// module chunks = 13